import { FallbackIconType } from "@ppb/the-wall-common/types";

import { RacingSport, VirtualSport } from "../constants";

export const getSilkFallbackType = (sportId: number): FallbackIconType | undefined => {
  switch (sportId) {
    case VirtualSport.HorsesFlat:
    case VirtualSport.HorsesJumps:
    case VirtualSport.HorsesSprint:
    case RacingSport.HORSE_RACING:
      return FallbackIconType.HorseRacing;
    default:
      return undefined;
  }
};

export const getRaceSport = (sportId: number): RacingSport | undefined => {
  switch (sportId) {
    case RacingSport.HORSE_RACING:
    case RacingSport.GREYHOUND_RACING:
      return sportId;
    default:
      return undefined;
  }
};
